import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import ReactSummernote from 'react-summernote';

const NoteEditor = ({title, content, onSubmit}) => {
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState(content)

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false); 

  return (
    <React.Fragment>
      <a href="#" onClick={onOpenModal}><i className="fa fa-pen"></i></a>
      <Modal open={open} onClose={onCloseModal} classNames={{ modal: 'edit-note-modal' }} >
        <h2>{title}</h2>
        <form onSubmit={(event) => {onSubmit(event, body); setOpen(false)}}>
          <div className="from-group">
            <ReactSummernote
            options={{
              height: 300,
              dialogsInBody: true,
              toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['insert', ['picture', 'gif', 'link']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['misc', ['undo', 'redo', 'fullscreen', 'codeview']],
              ],
            }}
            onInit={({summernote}) => summernote('code', body)}
            shouldComponentUpdate={() => {}}
            onChange={(content) => setBody(content)} />
            <button className='btn btn-secondary' type='button' onClick={onCloseModal}>Close</button>
            <input type="submit" className='btn btn-primary' value="Update note" />
          </div>
        </form>
      </Modal>
    </React.Fragment>
  )
};

export default NoteEditor;